<template>
  <div class="drag-icon-wrap"
    v-if="!inApp"
    ref="dragIcon"
    :style="{'left': left+'px','top': top+'px'}"
    @touchstart="(e) => { dragStart(e) }"
    @touchend="(e) => { dragEnd(e) }"
    @touchmove.prevent="(e) => { dragProgress(e) }"
    @click="goHelp">
    <img-v3 :src="icon_url" alt="" />
  </div>
</template>
<script>
import { mapState } from "vuex";
import { openWebview } from '../../tools/utils';
import { getEnd } from "../../tools/utils";
import { ends } from '../../tools/constant';
import iconHelpOld from '../../images/icon_help_old.png';
export default {

  data () {
    return {
      isShow: false,
      gapWidth: 5,
      left: 20,
      top: 20,
      clientWidth: 0,
      clientHeight: 0,
      itemWidth: 44, // 图标的宽度
      itemHeight: 44 // 图标的高度
    };
  },
  created() {

    this.clientWidth = document.documentElement.clientWidth;
    this.clientHeight = document.documentElement.clientHeight;
    this.left = this.clientWidth - this.itemWidth - this.gapWidth - 5; // 5:初始化给icon右边留出间隙
    this.top = this.clientHeight * 0.77;

  },
  mounted() {
    this.$nextTick(() => {
      let icon_dom = document.querySelector('.drag-icon-wrap')
      let height = icon_dom && icon_dom.getBoundingClientRect().height;
      if (height) {
        this.itemWidth = height;
        this.itemHeight = height;
      }
    })
    if (this.inApp) {
      Fusion.addCornerButton({
        btnName: this.$t('GDriver_Help_Help_iwNG'), // 记得改文案
        jsCallback: '_REGISTER_HELP_CB',
        btnTitleColor: '#ffffff',
      })
      window._REGISTER_HELP_CB = () => {
        this.omegaEvent();
        // 记得改链接
        let up = new URLSearchParams(location.search)
        // 乘客端记得处理token
        if (this._ticket) {
          up.set('ticket', this._ticket)
        }
        // let url = `${process.env.HELP_URL}?${up}`
        let url = `${this._help_icon_url}?${up}`
        openWebview(url);
      }
    }
  },
  computed: {
    ...mapState(["_ticket", "_help_icon", "_help_icon_url", "_help_icon_icon_url", "_product", "_uuid"]),
    inApp() {
      return false
    },
    icon_url() {
      return this._help_icon_icon_url || iconHelpOld;
    },
    params() {
      return new URLSearchParams(location.search);
    },
    location_country() {
      return this.params.get("location_country");
    },
    omegaItem() {
      return {
        channel: this.params.get("channel") || "",
        end: getEnd(),
        oid: this.params.get("oid") || Omega.getOmgid(),
        location_country_code: this.location_country,
        driver_id: this.params.get("uid") || this._uuid + "",
        page: this._help_icon_icon_url ? 1 : 0
      };
    },
  },
  methods: {
    dragStart(e) {
      this.$refs.dragIcon.style.transition = 'none';
    },
    dragEnd(e) {
      this.$refs.dragIcon.style.transition = 'all 0.3s';
      if (this.left > this.clientWidth/2) {
          this.left = this.clientWidth - this.itemWidth - this.gapWidth;
      } else {
          this.left = this.gapWidth;
      }
    },
    dragProgress(e) {
      if (e.targetTouches.length === 1) {
          let touch = event.targetTouches[0];
          this.left = touch.clientX - this.itemWidth/2;
          let top = touch.clientY - this.itemHeight/2;
          let bottom = this.clientHeight - (touch.clientY + this.itemHeight/2);
          if (top < 0) {
            this.top = 1
          } else {
            if (bottom < 0) {
              this.top = this.clientHeight - this.itemHeight - 2;
            } else {
              this.top = top;
            }
          }

      }
    },
    goHelp() {
      this.omegaEvent();
      // 记得改链接
      let up = new URLSearchParams(location.search)
      if (this._ticket) {
        up.set('ticket', this._ticket)
      }
      if (this._ticket || up.get('ticket')) {
        up.set('product', this._product)
      }
      let l = this._help_icon_url;
      if (l.indexOf("?") > -1) {
        l = `${l}&${up}`;
      } else {
        l = `${l}?${up}`;
      }
      // let url = `${this._help_icon_url}?${up}`
      if (ends.inApp) {
        // alert(url)
        openWebview(l)
      } else {
        window.open(l)
      }

    },
    omegaEvent() {
      let step = 8
      let name = this.$route.name
      if (/^login/.test(name)) {
        step = 0; //注册页
      } else if (/^productInfo/.test(name)) {
        step = 1; // 产品线选择页
      } else if (/^typeInfo/.test(name)) {
        step = 2; // 角色选择页
      } else if (/^workInfo/.test(name)) {
        step = 9; // 工作选择页-新增
      } else if (/^baseInfo/.test(name)) {
        step = 3; // 基础信息页
      } else if (/^photoInfo/.test(name)) {
        step = 4; // 证件列表页
      } else if (/^result/.test(name)) {
        step = 5; // 结果页
      } else if (/^downloadInfo/.test(name)) {
        step = 6; // 下载引导页
      } else if (/^prepareInfo/.test(name)) {
        step = 7; // 准备页
      } else {
        step = 8; // 其他页面
      }

      Omega.trackEvent("ibt_gd_help1h5_btn_ck", "", {
        ...this.omegaItem,
        "step": step
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.drag-icon-wrap {
  position: fixed;
  // bottom: 20px;
  // right: 20px;
  width: .96rem;
  height: .96rem;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 4px 30px 0 rgba(0,0,0,0.16);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  > img {
    width: .96rem;
    height: .96rem;
  }
}
</style>


